/* QUICK-SPECS: the Step 3 quick-buttons block (Front / Brake Style / Rear) is a foldable "Quick Specs" card in both builders.
 * The header is a real button (aria-expanded / aria-controls; Enter and Space toggle); clicking anywhere on it folds or opens
 * the body. Starts open; the folded/open state is remembered for the browser session (sessionStorage, optional). The classic
 * renderer keeps drawing the three columns inside the body as before; this file only owns the fold.
 */
(function (global) {
  'use strict';
  var KEY = 'loamQuickSpecsFolded';
  function readFolded() { try { return global.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function writeFolded(v) { try { global.sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) { /* storage unavailable: the fold still works for this page */ } }
  function apply(folded) {
    var card = document.getElementById('spec-adjuster-section'), btn = document.getElementById('quick-specs-toggle'), body = document.getElementById('quick-specs-body');
    if (!card || !btn) return;
    card.classList.toggle('is-folded', folded);
    btn.setAttribute('aria-expanded', folded ? 'false' : 'true');
    if (body) body.setAttribute('aria-hidden', folded ? 'true' : 'false');
  }
  function init() {
    var btn = document.getElementById('quick-specs-toggle'); if (!btn) return;
    apply(readFolded());
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); // the classic adjuster click handler on the same section only looks at spec buttons anyway
      var folded = !document.getElementById('spec-adjuster-section').classList.contains('is-folded');
      apply(folded); writeFolded(folded);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  global.LoamQuickSpecs = { fold: function (v) { apply(!!v); writeFolded(!!v); }, isFolded: function () { var c = document.getElementById('spec-adjuster-section'); return !!(c && c.classList.contains('is-folded')); } };
})(window);
